// reduxjs toolkit
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import BaseUrl from '../../service/API/base_url';
import { handleSuccess, handleError } from '../../utils/toast';

// view all feedbacks
export const viewFeedbacks = createAsyncThunk('feedback', async thunkAPI => {
  try {
    //response
    let response = await axios.get(`${BaseUrl}dorm-api/feedbacks`);

    // condition
    if (response.status === 200) {
      return response.data;
    } else {
      handleError(response.message);
      return thunkAPI.rejectWithValue(response.data);
    }
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
// get single feedbacks
export const singleFeedbacks = createAsyncThunk(
  'feedback',
  async (id, thunkAPI) => {
    try {
      //response
      let response = await axios.get(`${BaseUrl}dorm-api/feedbacks/${id}`, id);
      //condition
      if (response.status === 201) {
        return response.data.feedbackss;
      } else {
        handleError(response.message);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);
// send messages
export const sendMessage = createAsyncThunk(
  'feedback',
  async (feedbacksData, thunkAPI) => {
    try {
      //response
      let response = await axios.post(
        `${BaseUrl}dorm-api/feedbacks`,
        feedbacksData,
      );
      //condition
      if (response.status === 201) {
        handleSuccess('Send message successfull !');
        return response.data;
      } else {
        handleError(response.message);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      handleError(e.response.data.message);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);
// delete feedbacks
export const deleteFeedbacks = createAsyncThunk(
  'feedback',
  async (id, thunkAPI) => {
    try {
      let response = await axios.delete(`${BaseUrl}dorm-api/feedbacks/${id}`);
      if (response.status === 201) {
        handleSuccess('delete successfull !');
        return response.data.feedbacks;
      } else {
        handleError(response.message);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      handleError(e.response.data.message);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);
